import {Component, Input, OnInit} from '@angular/core';
import {School} from "../../../model/rest/casa-apiv2.model";

@Component({
    selector: 'app-students-payment-summary-block',
    templateUrl: './students-payment-summary-block.component.html',
    styleUrls: ['./students-payment-summary-block.component.css'],
    standalone: false
})
export class StudentsPaymentSummaryBlockComponent implements OnInit {
  private mSchool: School;

  @Input()
  set school(value: School) {
    this.mSchool = value;
  }

  constructor() {
  }

  ngOnInit() {
  }

  isReady() {
    return this.mSchool;
  }
}
